import { PosBffApi, PosChangePointType } from '@kinderlabs-pos/apis/pos';
import { GuestVisitQueryState } from '@kinderlabs-pos/state';
import { QueryClient } from '../QueryClient';

const usePoint = () => {
	return QueryClient.useMutation(
		async (args: PosChangePointType) => {
			await PosBffApi.usePoint(args);
		},
		{
			onSuccess: (data) => {
				GuestVisitQueryState.invalidateQueries();
			},
		}
	);
};

const refundPoint = () => {
	return QueryClient.useMutation(
		async (args: PosChangePointType) => {
			await PosBffApi.refundPoint(args);
		},
		{
			onSuccess: (data) => {
				GuestVisitQueryState.invalidateQueries();
			},
		}
	);
};
const rewardPoint = () => {
	return QueryClient.useMutation(
		async (args: PosChangePointType) => {
			await PosBffApi.rewardPoint(args);
		},
		{
			onSuccess: (data) => {
				GuestVisitQueryState.invalidateQueries();
			},
		}
	);
};

export const PosPointState = {
	usePoint,
	refundPoint,
	rewardPoint,
};
